import React, { useState, useEffect, useContext, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import SideMenu from "./SideMenu";
import GeneralInformationSection from "./MyInformation/GeneralInformationSection";
import CitizenshipSection from "./MyInformation/CitizenshipSection";
import ContactInformation from "./MyInformation/ContactInformation";
import HomeAddress from "./MyInformation/HomeAddress";
import DriversLicense from "./MyInformation/DriversLicense";
import OtherInformation from "./MyInformation/OtherInformation";
import EmploymentInformation from "./MyInformation/EmploymentInformation";
import MemberInformation from "./MyInformation/MemberInformation";
import { FaRegSave } from "react-icons/fa";

import RequireLogin from "../../permissions.js/RequireLogin";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import CustomButton from "../Common/CustomButton";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import PageLoader from "../Common/PageLoader";
import { UserContext } from "../../Context/user_context";

function MyInformation() {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useContext(UserContext);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const [employmentPass, setEmploymentPass] = useState(false);
  const [submitPass, setSubmitPass] = useState(false);

  const fetchData = useCallback(async () => {
    const contactid = Cookies.get("hippocratic_portal_contactid");
    setIsLoading(true);
    try {
      const res = await getApiClient().getUserInfo(contactid);
      if (res) {
        setData(res.data);
      }
    } catch (error) {
      makeStandardApiErrorHandler((error) => toast.error("error"))(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const refetchData = useCallback(async () => {
    const contactid = Cookies.get("hippocratic_portal_contactid");
    try {
      const res = await getApiClient().getUserInfo(contactid);
      if (res) {
        setData(res.data);
      }
    } catch (error) {
      console.error("Error refetching data:", error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);



  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; My Information
          </NavigationInformation>
          <Title>My Information</Title>
        </TopSection>
        <BottomSection>
        
          <SideMenu />
          
            {data && <MemberInformation error={error} message={message} user= {user} submitPass={submitPass} setSubmitPass={setSubmitPass} employmentPass={employmentPass} setEmploymentPass={setEmploymentPass} setMessage={setMessage} setError={setError} setData={setData} data={data} refetchData={refetchData} />}


        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const PageInfoTitle = styled.div`
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 23.402px;
`;





const EditButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #87a9bf;
  font-size: 16px;
  font-style: italic;
  text-decoration: underline;
`;

export default RequireLogin(MyInformation);
